var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import ReactDOM from 'react-dom';
import SelectBar from '../components/SelectBar';
import ReservationModal from '../components/ReservationModal';
import RestaurantBookingButtonsAndAlerts from '../components/Restaurant/buttons/RestaurantBookingButtonsAndAlerts';
import OtoError from '../components/common/OtoError';
import { isDaySame, isToday, parseDate, tomorrow } from '../app/date-helpers';
import { canBookTodayForHour } from '../app/time-helpers';
import { enablePopover } from '../app/ui';
import { getSafePeopleAmount } from '../app/general';
import { getInstantBookings } from '../services/api';
import { DEFAULT_VALUES, MAX_GROUP } from '../config';
import { instantBookingsErrorState, instantBookingsInitialState, } from '../app/shapes/main';
import LogService, { createDerivedStateFromErrorLogger, logComponentDidCatch, } from '../utils/log';
import { checkAndLogPWAUsage } from '../pwa';
import { getSource } from '../utils/tracking';
import { getHoursRange } from 'Utils/reservation';
import { initSentry } from 'App/services/sentry';
import Restaurant, { getSelectedDayOpeningHours } from 'Utils/restaurant';
var urlParams = new URLSearchParams(window.location.search);
var initialPeopleAmount = parseInt(urlParams.get('peopleAmount') || DEFAULT_VALUES.peopleAmount.toString(), 10);
var initialVisitTime = urlParams.get('visitTime') || DEFAULT_VALUES.visitTime;
var initialVisitDate = (urlParams.get('visitDate') && parseDate(urlParams.get('visitDate'))) || tomorrow;
var defaultReservationHours = getHoursRange(32400, 75600);
var COMPONENT_NAME = 'Iframe';
var OtoStolikIframe = /** @class */ (function (_super) {
    __extends(OtoStolikIframe, _super);
    function OtoStolikIframe() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            restaurant: window.restaurant,
            allHours: defaultReservationHours,
            hours: defaultReservationHours,
            peopleAmount: initialPeopleAmount,
            selectBarVisitTime: initialVisitTime,
            visitDate: initialVisitDate,
            visitTime: initialVisitTime,
            selectedRestaurant: null,
            instantBookings: instantBookingsInitialState,
            showTooBigGroupAlert: false,
            hasError: false,
        };
        _this.handleDateChange = function (date) {
            var isSameDaySelected = isDaySame(_this.state.visitDate, date);
            _this.setState({ visitDate: date }, _this.updateInstantBookings);
            if (isSameDaySelected) {
                return;
            }
            if (isToday(date)) {
                var newValidHours = _this.state.allHours.filter(canBookTodayForHour);
                newValidHours.length &&
                    _this.handleTimeChange({ target: { value: newValidHours[0] } });
                _this.setState({ hours: newValidHours });
            }
            else {
                _this.setState({ hours: _this.state.allHours });
            }
        };
        _this.handleTimeChange = function (event) {
            var visitTime = event.target.value;
            _this.setState({
                visitTime: visitTime,
                selectBarVisitTime: visitTime,
            }, _this.updateInstantBookings);
        };
        _this.handlePeopleAmountChange = function (event) {
            var value = parseInt(event.target.value, 10);
            var isTooBig = value > MAX_GROUP;
            var newState = __assign(__assign({}, _this.state), { peopleAmount: isTooBig ? MAX_GROUP : value, showTooBigGroupAlert: isTooBig });
            _this.setState(newState, _this.updateInstantBookings);
        };
        _this.reservationHourClick = function (selectedRestaurant, btnTime) {
            if (btnTime === void 0) { btnTime = _this.state.visitTime; }
            return _this.setState({
                selectedRestaurant: selectedRestaurant,
                visitTime: btnTime,
            });
        };
        _this.clearSelectedRestaurant = function () { return _this.setState({ selectedRestaurant: null }); };
        return _this;
    }
    OtoStolikIframe.prototype.componentDidMount = function () {
        enablePopover();
        checkAndLogPWAUsage("".concat(COMPONENT_NAME, " for ").concat(this.state.restaurant.id));
    };
    OtoStolikIframe.prototype.componentDidCatch = function (error, info) {
        logComponentDidCatch(COMPONENT_NAME, error, info);
    };
    OtoStolikIframe.prototype.updateInstantBookings = function () {
        var _this = this;
        var _a = this.state, peopleAmount = _a.peopleAmount, restaurant = _a.restaurant, visitTime = _a.visitTime, visitDate = _a.visitDate;
        var errorCb = function () {
            _this.setState({ instantBookings: instantBookingsErrorState });
        };
        this.setState({
            instantBookings: __assign(__assign({}, this.state.instantBookings), { loading: true, error: false }),
        });
        getInstantBookings({
            ids: [restaurant.id],
            peopleAmount: getSafePeopleAmount(peopleAmount),
            visitDate: visitDate,
            visitTime: visitTime,
        }, errorCb)
            .then(function (data) {
            _this.setState({
                instantBookings: {
                    loading: false,
                    error: false,
                    data: data,
                },
            });
        })
            .catch(function (e) {
            LogService.error("".concat(COMPONENT_NAME, " caught error while updating instant bookings"), e);
            _this.setState({ instantBookings: instantBookingsErrorState });
        });
    };
    OtoStolikIframe.prototype.render = function () {
        var _a = this.state, visitDate = _a.visitDate, visitTime = _a.visitTime, selectBarVisitTime = _a.selectBarVisitTime, peopleAmount = _a.peopleAmount, selectedRestaurant = _a.selectedRestaurant, hasError = _a.hasError;
        if (hasError) {
            return React.createElement(OtoError, { className: "first-after-header mx-2" });
        }
        var safePeopleAmount = peopleAmount && !isNaN(peopleAmount)
            ? peopleAmount
            : DEFAULT_VALUES.peopleAmount;
        var source = getSource(urlParams);
        return (React.createElement("div", null,
            React.createElement(SelectBar, { className: "select-bar--iframe", handleDateChange: this.handleDateChange, handleTimeChange: this.handleTimeChange, handlePeopleAmountChange: this.handlePeopleAmountChange, visitDate: visitDate, visitTime: selectBarVisitTime, peopleAmount: peopleAmount, reservationHours: this.state.hours }),
            this.renderBody(),
            selectedRestaurant ? (React.createElement(ReservationModal, { hideModal: this.clearSelectedRestaurant, restaurant: selectedRestaurant, visitDate: visitDate, visitTime: visitTime, peopleAmount: safePeopleAmount, showEmailField: Restaurant.requiresEmailForReservation(selectedRestaurant), showMarketingFields: Restaurant.wantsToCollectMarketingAgreemtnts(selectedRestaurant), source: source })) : null));
    };
    OtoStolikIframe.prototype.renderBody = function () {
        var _a = this.state, instantBookings = _a.instantBookings, visitDate = _a.visitDate, visitTime = _a.visitTime, peopleAmount = _a.peopleAmount, restaurant = _a.restaurant;
        var selectedDayHours = getSelectedDayOpeningHours(restaurant.opening_hours, visitDate);
        var notYetPartnersAgain = [29, 89, 113, 131];
        return (React.createElement(RestaurantBookingButtonsAndAlerts, { canBookNonPartner: notYetPartnersAgain.includes(restaurant.id), centerWrapperClass: "w-100 text-center", restaurantHoursClass: "restaurant__hours--iframe", selectedDayHours: selectedDayHours, instantBookings: instantBookings, peopleAmount: getSafePeopleAmount(peopleAmount), visitDate: visitDate, visitTime: visitTime, restaurant: restaurant, handleReservationClick: this.reservationHourClick }));
    };
    OtoStolikIframe.displayName = COMPONENT_NAME;
    OtoStolikIframe.getDerivedStateFromError = createDerivedStateFromErrorLogger(COMPONENT_NAME);
    return OtoStolikIframe;
}(React.PureComponent));
export default OtoStolikIframe;
if (process.env.NODE_ENV !== 'test') {
    initSentry();
    ReactDOM.render(React.createElement(OtoStolikIframe, null), document.getElementById('app'));
}
